/* global axios */
import ApiClient from '../ApiClient';

// Masifi: Panel de Control (brand-resellers-design.md §4). Account-scoped: la cuenta de la URL es solo el ancla de
// sesión; el backend decide el alcance (Masifi::Console::Scope).
class MasifiConsoleAPI extends ApiClient {
  constructor() {
    super('masifi/console', { accountScoped: true });
  }

  me() {
    return axios.get(`${this.url}/me`);
  }

  summary() {
    return axios.get(`${this.url}/summary`);
  }

  accounts(params = {}) {
    return axios.get(`${this.url}/accounts`, { params });
  }

  account(id) {
    return axios.get(`${this.url}/accounts/${id}`);
  }

  createAccount(payload) {
    return axios.post(`${this.url}/accounts`, payload);
  }

  updateAccount(id, payload) {
    return axios.patch(`${this.url}/accounts/${id}`, payload);
  }

  suspend(id, payload) {
    return axios.post(`${this.url}/accounts/${id}/suspend`, payload);
  }

  reactivate(id) {
    return axios.post(`${this.url}/accounts/${id}/reactivate`);
  }

  resendInvitation(id, userId) {
    return axios.post(`${this.url}/accounts/${id}/resend_invitation`, {
      user_id: userId,
    });
  }

  auditEvents(params = {}) {
    return axios.get(`${this.url}/audit_events`, { params });
  }

  cloudflare() {
    return axios.get(`${this.url}/cloudflare`);
  }

  refreshCloudflare() {
    return axios.post(`${this.url}/cloudflare/refresh`);
  }

  applyCloudflareItem(key) {
    return axios.post(`${this.url}/cloudflare/items/${key}/apply`);
  }
}

export default new MasifiConsoleAPI();
